import React, { useState } from "react";
import "../Navbar/Navbar.css";
import logo from "../Assets/logo.png";
import { Link, NavLink } from "react-router-dom";
import { IoMdMenu, IoMdCloseCircle } from "react-icons/io";

function Navbar() {
  const [openMenu, setOpenMenu] = useState(false);

  const handleClick = () => {
    setOpenMenu(!openMenu);
  };

  const closeMenu = () => {
    setOpenMenu(false);
  };

  return (
  <>
  <div className="navbar">
      <div className="logo-div">
        <Link to="/" className="logo-style">
          <img src={logo} alt="Medisol" className="logo" />
          <br />
          <span className="text-decoration-none text-center">
            B r e a t h e r &nbsp; f o r &nbsp; L i f e
          </span>
        </Link>
      </div>

      <div className={openMenu ? "nav-menu open" : "nav-menu close"} onClick={closeMenu}>
        <NavLink to="/" className="menu-name" >
          Home
        </NavLink>
        <NavLink to="/about" className="menu-name" >
          About Us
        </NavLink>
        <NavLink to="/product" className="menu-name" >
          Product
        </NavLink>
        <NavLink to="/mdi" className="menu-name" >
          MDIs
        </NavLink>
        <NavLink to="/quality" className="menu-name" >
          Quality
        </NavLink>
        <NavLink to="/technology" className="menu-name" >
          Technology
        </NavLink>
        <NavLink to="/contact" className="menu-name">
          Contact Us
        </NavLink>
      </div>

      <div className="bars" onClick={handleClick}>
        {!openMenu ? <IoMdMenu /> : <IoMdCloseCircle />}
      </div>
    </div>
  </>
  );
}

export default Navbar;
